import { Injectable } from '@angular/core';
import {Job} from "../entities/Job";
import {BehaviorSubject} from "rxjs";
import {AppConfig} from '../app.config';
import {productModels} from '../../environments/environment';
import { ActivatedRoute } from '@angular/router';

@Injectable()
export class ConfigService {

  chosenJob : Job;
  observableJob : BehaviorSubject<Job>;


  isJobRelevant : boolean = true;
  observableIsJobsRelevant : BehaviorSubject<boolean>;

  currentRoute : string;
  observableRoute : BehaviorSubject<string>;

  public productModels = productModels;
  public currentProductModel : any;
  public defaultLanguage: string;

  constructor(private appConfig : AppConfig){
    this.currentProductModel = this.appConfig.getConfig("productModel");
    this.defaultLanguage = this.appConfig.getConfig("language")

    if(this.currentProductModel == productModels.Premium){
      this.chosenJob = {No: 'Alle sager'};
    }
    if(this.currentProductModel == productModels.Lite){
      this.chosenJob = {No: 'Alle sager'};
    }
    else if(this.currentProductModel == productModels.Maintenance) {
      this.chosenJob = {No: 'Alle'};
      this.chosenJob.start = new Date().toISOString();
      this.chosenJob.end = new Date().toISOString();

    }

    this.observableJob = new BehaviorSubject<Job>(this.chosenJob);
    this.observableIsJobsRelevant = new BehaviorSubject<boolean>(this.isJobRelevant)
    this.observableRoute = new BehaviorSubject<string>(this.currentRoute);
  }

  getJobFromSessionStorage() : Job
  {
    if(sessionStorage.getItem('chosenJob') != null && sessionStorage.getItem('chosenJob') != "") {
      this.chosenJob = JSON.parse(sessionStorage.getItem('chosenJob'))
    }
    return this.chosenJob;
  }

  changeJob(job)
  {
    this.chosenJob = job;
    sessionStorage.setItem('chosenJob', JSON.stringify(job));
    this.jobChanged();
  }

  getDefaultLanguage(): string
  {
    return this.defaultLanguage;
  }

  getLanguageFromURL(): string{
    const pathParts = window.location.pathname.split("/");
    const language = pathParts[1];

    if (!language || language.indexOf("?") !== -1) {
      return this.getDefaultLanguage();
    }

    return language;
  }

  private jobChanged() {
    this.observableJob.next(this.chosenJob);
  }

  changeJobRelevance(isIt : boolean)
  {
    this.isJobRelevant = isIt;
    this.jobRelevanceChanged();
  }

  private jobRelevanceChanged()
  {
    this.observableIsJobsRelevant.next(this.isJobRelevant);
  }

  changeCurrentRoute(route : string)
  {
    this.currentRoute = route;
    this.currentRouteChanged();
  }

  private currentRouteChanged()
  {
    this.observableRoute.next(this.currentRoute);
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/config.service.ts